import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterEvent,
} from '@angular/router';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { UserService } from 'src/app/core/services/user.service';
import { ICase } from '../../interfaces/case.interface';
import { CasesService } from '../../../../core/services/cases.service';
import { Subscription } from 'rxjs';
import { CaseService } from 'src/app/modules/case/services/case.service';
import { UnitsService } from 'src/app/core/services/units.service';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CreateCaseComponent } from '../create-case/create-case.component';
import { ConfirmComponent } from 'src/app/components/shared/components/confirm/confirm.component';
import { RemitCaseComponent } from '../remit-case/remit-case.component';
import { GenerateTasksComponent } from 'src/app/modules/case/components/generate-tasks/generate-tasks.component';
import { first } from 'rxjs/operators';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { FinishCaseComponent } from '../finishCase/finishCase.component';
import * as moment from 'moment';
import { SocketService } from 'src/app/core/services/socket.service';
@Component({
  selector: 'app-whitout-assigned-cases',
  templateUrl: './whitout-assigned-cases.component.html',
  styleUrls: ['./whitout-assigned-cases.component.scss'],
})
export class WhitoutAssignedCasesComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<ICase>;
  unitId!: string;
  valueTab: number = 0;
  durationInSeconds = 4;
  allCases = [];
  allCasesRunning = [];
  allCasesInitial = [];
  // toFinalize = [];
  allCasesAssigned = [];
  allCasesTobeApproved = [];
  allCasesRefused = [];
  loading = false;
  unitinfo = null;
  toFinalizeFillter = [];
  pendingFillter = [];
  initialFillter = [];
  runningFillter = [];
  toFinalize = [];
  pending = [];
  initial: ICase[] = [];
  running = [];
  showInitialData = false;
  showFinalizeData = false;
  showRunningData = false;
  showPendingData = false;
  showApprovedData = false;
  users: IUser[] = [];
  caseTypes: ICaseType[] = [];
  displayedColumns: string[] = [
    'options',
    'gai',
    'description',
    'caseType',
    'creator',
    'createdAt',
    'datePast',
  ];
  dataSource: MatTableDataSource<any>;
  status = {
    initial: 'Sin Asignar',
    running: 'En proceso',
    toFinalize: 'Finalizado',
    archived: 'Archivado',
    pending: 'Pendiente',
    assigned: 'Asignado',
    refused: 'Rechazado',
  };
  routerSuscription: Subscription;
  constructor(
    private readonly casesService: CasesService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    public userService: UserService,
    private readonly dialog: MatDialog,
    private readonly caseService: CaseService,
    private readonly unitService: UnitsService,
    private _snackBar: MatSnackBar,
    private socket: SocketService
  ) {
    // this.dataSource = new MatTableDataSource(users);

    this.routerSuscription = this.router.events.subscribe(
      async (event: RouterEvent) => {
        if (event instanceof NavigationEnd) {
          this.unitId = route.snapshot.paramMap.get('id');
          this.update();
          this.socketOn();
        }
      }
    );
    this.unitId = route.snapshot.paramMap.get('id');
  }
  update() {
    this.reset();
    this.getDataAssigned();
    this.getDataRunning();
    this.getDataInitial();
    this.getDataCasesTobeApproved();
    this.getDataCasestoFinalize();
    this.getDataAll();
  }
  socketOn() {
    console.log('SOCKET ON');
    this.socket.socket.on('new-alert', async (msj: { ok: boolean }) => {
      console.log('MessageReceived!', msj);
      this.update();
    });
  }
  ngOnDestroy(): void {
    this.routerSuscription?.unsubscribe();
  }
  ngAfterViewInit() {
    // this.dataSource.sort = this.sort;
    setTimeout(() => this.hideTabLabelsIfNoSeeCase(), 0);
  }

  hideTabLabelsIfNoSeeCase() {
    if (!this.canSeeGeneral) {
      const indicesToHide = [0, 5];
      const labels = document.querySelectorAll('.mat-tab-label');
      this.valueTab = 1;
      indicesToHide.forEach((idx) => {
        if (labels[idx]) {
          (labels[idx] as HTMLElement).style.display = 'none';
        }
      });
    } else {
      // Si canSee es true, asegúrate de mostrar los tabs por si antes estaban ocultos
      const indicesToShow = [0, 5];
      const labels = document.querySelectorAll('.mat-tab-label');
      indicesToShow.forEach((idx) => {
        if (labels[idx]) {
          (labels[idx] as HTMLElement).style.display = '';
        }
      });
    }
  }
  setData(cases: ICase[]) {
    this.dataSource = new MatTableDataSource(cases);
    this.dataSource.paginator = this.paginator;
  }

  edit(icase) {
    this.dialog
      .open(CreateCaseComponent, {
        width: '700px',
        maxHeight: '80vh',
        data: {
          unit: icase.caseType.unit,
          case: icase,
        },
      })
      .afterClosed()
      .subscribe({
        next: (caseUpdated: ICase) => {
          if (caseUpdated) {
            let cases;
            let index;

            switch (this.valueTab) {
              case 0:
                cases = this.allCasesAssigned;
                index = cases.findIndex((item) => item._id == caseUpdated._id);
                cases.splice(index, 1, caseUpdated);
                this.allCasesAssigned.splice(index, 1, caseUpdated);
                break;
              case 1:
                cases = this.allCasesRunning;
                index = cases.findIndex((item) => item._id == caseUpdated._id);
                cases.splice(index, 1, caseUpdated);
                this.allCasesRunning.splice(index, 1, caseUpdated);
                break;
              case 2:
                cases = this.allCasesInitial;
                index = cases.findIndex((item) => item._id == caseUpdated._id);
                cases.splice(index, 1, caseUpdated);
                this.allCasesInitial.splice(index, 1, caseUpdated);
                break;
              case 3:
                cases = this.toFinalize;
                index = cases.findIndex((item) => item._id == caseUpdated._id);
                cases.splice(index, 1, caseUpdated);
                this.toFinalize.splice(index, 1, caseUpdated);
                break;
              case 4:
                cases = this.allCases;
                index = cases.findIndex((item) => item._id == caseUpdated._id);
                cases.splice(index, 1, caseUpdated);
                this.allCases.splice(index, 1, caseUpdated);
                break;
              default:
                break;
            }
            this.setData(cases);
            this.table.renderRows();
          }
        },
      });
  }
  openSnackBar(icase) {
    const snackbarRef: MatSnackBarRef<any> = this._snackBar.open(
      'Caso eliminado',
      'Deshacer',
      {
        duration: 4000, // Duración del Snackbar en ms
      }
    );
    let deshacer = false;

    let cases;
    let index;

    switch (this.valueTab) {
      case 0:
        cases = this.allCasesAssigned;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1);
        this.allCasesAssigned.splice(index, 1);
        break;
      case 1:
        cases = this.allCasesRunning;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1);
        this.allCasesRunning.splice(index, 1);
        break;
      case 2:
        cases = this.allCasesInitial;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1);
        this.allCasesInitial.splice(index, 1);
        break;
      case 3:
        cases = this.toFinalize;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1);
        this.toFinalize.splice(index, 1);
        break;
      case 4:
        cases = this.allCases;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1);
        this.allCases.splice(index, 1);
        break;
      default:
        break;
    }

    this.setData(cases);
    this.table.renderRows();

    snackbarRef.onAction().subscribe(() => {
      deshacer = true;
      switch (this.valueTab) {
        case 0:
          index = cases.findIndex((item) => item._id == icase._id);
          cases.splice(index, 0, icase);
          this.allCasesAssigned.splice(index, 0, icase);
          break;
        case 1:
          index = cases.findIndex((item) => item._id == icase._id);
          cases.splice(index, 0, icase);
          this.allCasesRunning.splice(index, 0, icase);
          break;
        case 2:
          cases = this.allCasesInitial;
          index = cases.findIndex((item) => item._id == icase._id);
          cases.splice(index, 0, icase);
          this.allCasesInitial.splice(index, 0, icase);
          break;
        case 3:
          cases = this.allCases;
          index = cases.findIndex((item) => item._id == icase._id);
          cases.splice(index, 0, icase);
          this.allCases.splice(index, 0, icase);
          break;
        default:
          break;
      }
      this.setData(cases);
      this.table.renderRows();
    });
    setTimeout(() => {
      if (!deshacer) {
        this.caseService
          .delete(icase._id, this.userService.currentUser)
          .subscribe({
            next: () => {},
            error: (e) => {
              this.alert('Ha ocurrido un error al intentar eliminar el caso');
            },
          });
      }
    }, 4100);
  }

  async delete(icase) {
    let response = await this.confirm('¿Seguro deseas eliminar este caso?');
    if (response) {
      this.openSnackBar(icase);
    }
  }

  async seeCase(icase, status, a = undefined, b = undefined) {
    this.router.navigate([`/casesnew/${icase._id}`]);
  }

  confirm(message) {
    return new Promise((resolve) => {
      this.dialog
        .open(ConfirmComponent, {
          data: {
            title: message,
          },
        })
        .afterClosed()
        .subscribe({ next: (result) => resolve(result) });
    });
  }

  alert(message) {
    this.dialog.open(SuccessComponent, { data: { title: message } });
  }

  get canMove() {
    return this.userService.permissions.changeColumnCases;
  }
  get canSeeGeneral() {
    return this.userService.currentUser.role?.createCases;
  }

  ngOnInit() {
    // console.log("currentUser: ",this.userService.currentUser.role);
    this.casesService.caseCreated.subscribe({
      next: (newCase) => {
        this.initial.unshift(newCase);
        this.allCasesInitial.unshift(newCase);
        this.setData(this.allCasesInitial);
        this.table.renderRows();
      },
    });

    this.casesService.caseDeleted.subscribe({
      next: (caseDeleted) => {
        let index = 0;
        switch (caseDeleted.status) {
          case 'initial':
            index = this.initial.findIndex(
              (item) => item._id == caseDeleted._id
            );
            this.initial.splice(index, 1);
            break;
          case 'toFinalize':
            index = this.toFinalize.findIndex(
              (item) => item._id == caseDeleted._id
            );
            this.toFinalize.splice(index, 1);
            break;
          case 'running':
            index = this.running.findIndex(
              (item) => item._id == caseDeleted._id
            );
            this.running.splice(index, 1);
            break;
          case 'initial':
            index = this.initial.findIndex(
              (item) => item._id == caseDeleted._id
            );
            this.initial.splice(index, 1);
            break;
          case 'pending':
            index = this.pending.findIndex(
              (item) => item._id == caseDeleted._id
            );
            this.pending.splice(index, 1);
            break;
          default:
            console.log('Error');
            break;
        }
      },
    });
    this.casesService.caseEdited.subscribe({
      next: (caseEdited) => {
        let index = 0;
        switch (caseEdited.status) {
          case 'initial':
            index = this.initial.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.initial.splice(index, 1, caseEdited);
            break;
          case 'toFinalize':
            index = this.toFinalize.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.toFinalize.splice(index, 1, caseEdited);
            break;
          case 'running':
            index = this.running.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.running.splice(index, 1, caseEdited);
            break;
          case 'initial':
            index = this.initial.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.initial.splice(index, 1, caseEdited);
            break;
          case 'pending':
            index = this.pending.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.pending.splice(index, 1, caseEdited);
            break;
          case 'assigned':
            index = this.pending.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.pending.splice(index, 1, caseEdited);
            break;
          default:
            console.log('Error');
            break;
        }
      },
    });

    this.casesService.filterDataRasSearch.subscribe({
      next: (filters) => {
        this.getDataAssigned(filters);
        this.getDataRunning(filters);
        this.getDataInitial(filters);
        this.getDataCasesTobeApproved(filters);
        this.getDataCasestoFinalize(filters);
        this.getDataAll();
      },
    });

    this.casesService.caseFinished.subscribe({
      next: (caseFinished) => {
        const index = this.toFinalize.findIndex(
          (item) => item._id == caseFinished._id
        );
        this.toFinalize.splice(index, 1);
      },
    });

    this.getCaseTypes();
  }

  reset() {
    const types = ['initial', 'toFinalize', 'initial', 'running', 'pending'];
    for (const key of types) {
      this[key] = [];
    }

    switch (this.valueTab) {
      case 0:
        this.allCasesAssigned = [];
        break;
      case 1:
        this.allCasesRunning = [];
        break;
      case 2:
        this.allCasesInitial = [];
        break;
      case 3:
        this.toFinalize = [];
        break;
      case 4:
        this.allCases = [];
        break;
      default:
        break;
    }
  }

  get canFinish() {
    return this.userService.permissions?.finishCases;
  }

  async getDataAll(filters: any = {}) {
    this.loading = true;
    this.casesService
      .getListCasesWhitoutAssigned(this.unitId, filters)
      .subscribe({
        next: (data: any) => {
          this.loading = false;
          this.allCases = data.reverse();
        },
      });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }

  async getDataInitial(filters: any = {}) {
    filters.state = 'initial';
    this.loading = true;
    this.casesService
      .getListCasesWhitoutAssigned(this.unitId, filters)
      .subscribe({
        next: (data: any) => {
          this.loading = false;
          this.allCasesInitial = data.reverse();
          this.setData(this.allCasesInitial);
        },
      });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }

  async getDataAssigned(filters: any = {}) {
    filters.state = 'assigned';
    this.loading = true;
    this.casesService
      .getListCasesWhitoutAssigned(this.unitId, filters)
      .subscribe({
        next: (data: any) => {
          this.loading = false;
          this.allCasesAssigned = data.reverse();
        },
      });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }

  async getDataRunning(filters: any = {}) {
    filters.state = 'running';

    this.loading = true;
    this.casesService
      .getListCasesWhitoutAssigned(this.unitId, filters)
      .subscribe({
        next: (data: any) => {
          this.loading = false;
          this.allCasesRunning = data.reverse();
        },
      });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }

  async getDataCasesTobeApproved(filters: any = {}) {
    filters.state = 'tobeApproved';
    this.loading = true;
    this.casesService.getDataByUnitList(this.unitId, filters).subscribe({
      next: (data: any) => {
        this.loading = false;
        this.allCasesTobeApproved = data.reverse();
      },
    });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }
  async getDataCasestoFinalize(filters: any = {}) {
    filters.state = 'toFinalize';
    this.loading = true;
    this.casesService
      .getListCasesWhitoutAssigned(this.unitId, filters)
      .subscribe({
        next: (data: any) => {
          this.loading = false;
          this.toFinalize = data.reverse();
        },
      });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }
  nothing() {
    console.log('x');
  }

  get countRunning() {
    return this.running?.length;
  }

  get countInitial() {
    return this.initial?.length;
  }

  get countApproved() {
    return this.initial?.length;
  }

  get countFinalize() {
    return this.toFinalize?.length;
  }

  get countPending() {
    return this.pending?.length;
  }

  async orderByFilter(fil, status) {
    switch (status) {
      case 'initial':
        this[status + 'Filter'] = fil;
        break;
      case 'initial':
        this[status + 'Filter'] = fil;
        break;
      case 'pending':
        this[status + 'Filter'] = fil;
        break;
      case 'running':
        this[status + 'Filter'] = fil;
        break;
      case 'initial':
        this[status + 'Filter'] = fil;
        break;
    }
    this.casesService.getDataByUnitFilter(this.unitId, {}).subscribe({
      next: (data: any) => {
        this.loading = false;
        this[status] = data[status];
        //si tiene analista
        if (fil.analist) {
          this[status] = this[status].filter((r) => {
            return r.assigned._id == fil.analist;
          });
        }
        if (fil.caseType) {
          this[status] = this[status].filter((r) => {
            return r.caseType._id == fil.caseType;
          });
        }
        if (fil.date && fil.date != null) {
          this[status] = this[status]
            .slice()
            .sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            );
        }
        if (!fil.date && fil.date != null) {
          this[status] = this[status]
            .slice()
            .sort(
              (a, b) =>
                new Date(a.createdAt).getTime() -
                new Date(b.createdAt).getTime()
            );
        }
      },
    });
  }

  getCaseTypes() {
    this.unitService.getTypeCases(this.unitId).subscribe({
      next: (caseTypes) => {
        this.caseTypes = caseTypes;
        this.findUser();
      },
    });
  }

  findUser() {
    for (let caseType of this.caseTypes) {
      this.userService.getUsersByRole(caseType.role).subscribe({
        next: (users: any) => {
          this.users = [...this.users, ...users];
          const uniqueIds = new Set();

          this.users = this.users.filter((element) => {
            const isDuplicate = uniqueIds.has(element._id);

            uniqueIds.add(element._id);

            if (!isDuplicate) {
              return true;
            }

            return false;
          });
        },
      });
    }
  }

  approval(icase) {
    this.dialog
      .open(ConfirmComponent, {
        data: {
          title: '¿Deseas aprobar este caso?',
          type: null,
          approbvalStatus: icase.approvalStatus,
        },
        minWidth: '400px',
      })
      .afterClosed()
      .subscribe(async (response) => {
        if (response) {
          this.caseService.acceptApproval(icase._id).subscribe({
            next: async (updatedCase: any) => {
              const c = await this.getCaso(icase._id);
              await this.updateCase(c);
              this.alert('El caso ha sido aprobado');

              const remitInstructions: any = c.caseType.remitTo;
              const shouldRemit =
                remitInstructions &&
                remitInstructions.some(
                  (instruction) => instruction.remitIf === 'approved'
                );

              if (shouldRemit) {
                this.remitTo(c);
                return;
              }

              this.generateTasks(icase);
            },
          });
        }
      });
  }

  async getCaso(id) {
    const icase = await this.caseService.getCase(id).pipe(first()).toPromise();
    return icase;
  }

  async remitTo(icase) {
    if (!icase.caseType.remitTo || icase.caseType.remitTo.length === 0) {
      console.error(
        'remitTo fue llamado, pero no se encontraron instrucciones de remisión.'
      );
      this.generateTasks(icase);
      return;
    }

    const approvedDestinations = icase.caseType.remitTo.filter(
      (instruction) => instruction.remitIf === 'approved'
    );

    if (approvedDestinations.length === 0) {
      console.warn(
        "remitTo fue llamado, pero ninguna instrucción coincidía con 'approved'."
      );
      this.generateTasks(icase);
      return;
    }

    this.dialog
      .open(RemitCaseComponent, {
        width: '600px',
        maxHeight: '80vh',
        data: {
          case: icase,
          destinations: approvedDestinations,
        },
        disableClose: true,
      })
      .afterClosed()
      .subscribe({
        next: (remittalSucceeded: boolean) => {
          if (remittalSucceeded) {
            this.generateTasks(icase);
          }
        },
      });
  }

  finishCase(icase) {
    const { caseType } = icase;
    if (!caseType.remitTo || caseType.remitIf != 'finished')
      return this.finish(icase);
    this.dialog
      .open(RemitCaseComponent, {
        width: '600px',
        maxHeight: '80vh',
        data: icase,
        disableClose: true,
      })
      .afterClosed()
      .subscribe({
        next: (response) => {
          this.finish(icase);
        },
      });
  }

  finish(icase) {
    let appUnif: any;
    let secondAp = false;
    let controlRas;
    if (
      icase.caseType.approvalRoles?.levelTwo &&
      icase.approvalStatus == 'approved'
    ) {
      appUnif = icase?.apUnif;
    } else {
      appUnif = false;
    }

    if (icase?.caseType.approvalRoles?.levelTwo) secondAp = true;
    if (
      icase.caseType.approvalRoles?.levelTwo &&
      icase.approvalStatus == 'approved'
    ) {
      controlRas = icase?.numberRas ? true : false;
    } else {
      controlRas = false;
    }

    if (!appUnif && secondAp) {
      return this.alert('El caso no ha sido aprobado por UNIF');
    }
    if (!controlRas && secondAp) {
      return this.alert('El caso no posee Número de control RAS');
    }
    this.dialog
      .open(FinishCaseComponent, {
        width: '800px',
        maxHeight: '80vh',
        data: icase,
      })
      .afterClosed()
      .subscribe({
        next: (response) => {
          // this.getDataToFinalize();
          //cambiar
        },
      });
  }

  canControlRas(icase) {
    try {
      const { approvalRoles } = icase?.caseType;
      const { approvalStatus } = icase;
      const roleId = this.userService.currentUser.role._id;
      if (
        approvalRoles?.levelOne == roleId &&
        approvalStatus == 'approved' &&
        icase.caseType.name == 'RAS'
      ) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }

  controlRas(icase) {
    if (
      icase.caseType.approvalRoles?.levelTwo &&
      icase.approvalStatus == 'approved'
    ) {
      return icase?.numberRas ? true : false;
    } else {
      return false;
    }
  }

  generateTasks(icase) {
    if (icase.caseType.generateTasks.length > 0) {
      this.dialog.open(GenerateTasksComponent, {
        width: '900px',
        maxHeight: '80vh',
        data: {
          case: icase._id,
          caseType: icase.caseType._id,
        },
        disableClose: true,
      });
    }
  }

  updateCase(icase) {
    console.log('updateCase', icase);
    let cases;
    let index;

    switch (this.valueTab) {
      case 0:
        cases = this.allCasesAssigned;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1, icase);
        this.allCasesAssigned.splice(index, 1, icase);
        break;
      case 1:
        cases = this.allCasesRunning;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1, icase);
        this.allCasesRunning.splice(index, 1, icase);
        break;
      case 2:
        cases = this.allCasesInitial;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1, icase);
        this.allCasesInitial.splice(index, 1, icase);
        break;
      case 3:
        cases = this.allCasesTobeApproved;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1, icase);
        this.allCasesTobeApproved.splice(index, 1, icase);
        break;
      case 4:
        cases = this.toFinalize;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1, icase);
        this.toFinalize.splice(index, 1, icase);
        break;
      case 5:
        cases = this.allCases;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1, icase);
        this.allCases.splice(index, 1, icase);
        break;
      default:
        break;
    }

    this.setData(cases);
    this.table.renderRows();
  }

  needApproval(icase) {
    try {
      const { approvalRoles } = icase?.caseType;
      const { approvalStatus } = icase;
      const roleId = this.userService.currentUser.role._id;
      if (
        approvalRoles?.levelOne == roleId &&
        approvalStatus == 'requestLevelOne'
      ) {
        return true;
      }
      if (
        approvalRoles?.levelTwo == roleId &&
        approvalStatus == 'requestLevelTwo'
      ) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }

  change(value) {
    this.valueTab = value;

    switch (value) {
      case 0:
        this.setData(this.allCasesInitial);

        break;
      case 1:
        this.setData(this.allCasesAssigned);

        break;
      case 2:
        this.setData(this.allCasesRunning);
        break;
      case 3:
        this.setData(this.allCasesTobeApproved);

        break;
      case 4:
        this.setData(this.toFinalize);
        break;
      case 5:
        this.setData(this.allCases);
        break;
      default:
        break;
    }
    this.table.renderRows();
  }

  datePast(element) {
    let days;
    // if(element.status.toFinalize){
    // console.log("Element: ",element);
    // }
    const creationDate = element?.alert?.createdAt || element?.createdAt;

    if (!creationDate) {
      return 'Sin fecha';
    }

    switch (element?.status) {
      case 'toFinalize':
        days = moment(element.toFinalizeAt).diff(moment(creationDate), 'days');
        break;

      default:
        days = moment().diff(moment(creationDate), 'days');
    }

    return days;
  }
}
